import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';

@Pipe({
    name: 'severityLevelRag'
})
export class SeverityLevelRagPipe implements PipeTransform {

    transform(value: number): unknown {
        switch(value) {
            case 0: return null;
            case 1: return 'Green';
            case 2: return 'Amber';
            case 3: return 'Red';
        }

        return null;
    }

}
